// extracted by mini-css-extract-plugin
export var modalFooter = "_sk-0";